import React from 'react';
import {ProjectsUIProvider} from '../components/ProjectsUIContext';
import {CustomersForProjectsUIProvider} from "../components/CustomersForProjectsUIContext";
import {ProjectsLoadingDialog} from '../components/ProjectsLoadingDialog/ProjectsLoadingDialog';
import {ProjectsCard} from './ProjectsCard';

export function ProjectsPage() {
  return (
    <ProjectsUIProvider>
      <CustomersForProjectsUIProvider>
        <ProjectsLoadingDialog/>
        <ProjectsCard/>
      </CustomersForProjectsUIProvider>
    </ProjectsUIProvider>
  );
}
